import { Component, OnInit } from '@angular/core';
import { ReservationService } from '../../services/reservation.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HostingService } from '../../services/hosting.service';
import { Hosting } from '../../models/HostingModel';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { AdminHotelNavbarComponent } from '../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { NavbarComponent } from "../../components/navbar/navbar.component";

@Component({
  selector: 'app-admin-hotel-create-reservations',
  standalone: true,
  imports: [FormsModule, CommonModule, AdminHotelNavbarComponent, NavbarComponent],
  templateUrl: './admin-hotel-create-reservations.component.html',
  styleUrl: './admin-hotel-create-reservations.component.css'
})
export class AdminHotelCreateReservationsComponent implements OnInit {
  clienteEmail: string = '';
  clienteDocumento: string = '';
  clienteBusquedaError: string = '';
  noches: number = 0;
  habitaciones: any[] = [];
  alojamientosIds: string[] = [];
  alojamientos: Hosting[] = [];
  serviciosAdicionales: any[] = [];
  serviciosSeleccionados: any[] = [];
  total: number = 0;
  huespedes: any[] = [];
  huespedTemp: any = { name: '', lastName: '', idType: 'Cédula de Ciudadanía', idNumber: '', phone: '', emergencyPhone: '' };
  form = {
    hotelId: '',
    roomId: '',
    checkInDate: '',
    checkOutDate: '',
    numAdults: 1,
    numChildren: 0,
    numInfants: 0,
    roomCost: 0,
    additionalServices: [] as any[]
  };
  loading = false;
  error: string | null = null;
  success: string | null = null;
  mensajeHuespedes: string = '';
  clienteId: string = '';

  constructor(
    private readonly authService: AuthService,
    private readonly reservationService: ReservationService,
    private readonly tokenStorage: TokenStorageService,
    private readonly hostingService: HostingService,
  ) {}

  async buscarCliente() {
    this.clienteBusquedaError = '';
    this.clienteId = '';
    if (!this.clienteEmail && !this.clienteDocumento) {
      this.clienteBusquedaError = 'Ingrese el email o documento del cliente.';
      return;
    }
    try {
      const response = await this.authService.findUserByEmailOrDocument(this.clienteEmail, this.clienteDocumento);
      if (response && response.user && response.user.id) {
        this.clienteId = response.user.id;
        this.clienteBusquedaError = '';
      } else {
        this.clienteBusquedaError = 'No se encontró el usuario con ese email o documento.';
      }
    } catch (err: any) {
      this.clienteBusquedaError = err?.message || 'Error buscando el usuario.';
    }
  }


  ngOnInit() {
    this.extraerAlojamientosDelToken();
    this.cargarAlojamientosAsync();
  }

  agregarHuesped() {
    if (!this.huespedTemp.name || !this.huespedTemp.lastName || !this.huespedTemp.idNumber || !this.huespedTemp.phone) return;
    this.huespedes.push({ ...this.huespedTemp });
    this.huespedTemp = { name: '', lastName: '', idType: 'Cédula de Ciudadanía', idNumber: '', phone: '', emergencyPhone: '' };
  this.validarCantidadHuespedes();
  this.calcularTotal();
  }

  eliminarHuesped(idx: number) {
    this.huespedes.splice(idx, 1);
  this.validarCantidadHuespedes();
  this.calcularTotal();
  }

  cargarHabitaciones(hotelId: string) {
    this.habitaciones = [];
    const alojamiento = this.alojamientos.find(a => a.id === hotelId);
    if (!alojamiento) {
      this.serviciosAdicionales = [];
      this.serviciosSeleccionados = [];
      this.form.roomId = '';
      this.form.roomCost = 0;
      this.calcularTotal();
      this.validarCantidadHuespedes();
      return;
    }
    if (alojamiento.room) {
      this.habitaciones = [alojamiento.room];
    }
    // Si en el futuro hay alojamiento.rooms como array, puedes usar:
    // this.habitaciones = alojamiento.rooms || [];
    // Cargar servicios adicionales
    this.serviciosAdicionales = alojamiento.additional || [];
    this.serviciosSeleccionados = [];
    this.form.roomId = '';
    this.form.roomCost = 0;
    this.calcularTotal();
    this.validarCantidadHuespedes();
  }

  onHabitacionChange(roomId: string) {
    const habitacion = this.habitaciones.find(h => h.room_id === roomId);
    if (habitacion) {
      this.form.roomCost = Number(habitacion.price_per_night) || 0;
    } else {
      this.form.roomCost = 0;
    }
    this.calcularTotal();
  this.validarCantidadHuespedes();
  }

  toggleServicioAdicional(servicio: any) {
    servicio.selected = !servicio.selected;
    if (servicio.selected) {
      this.serviciosSeleccionados.push(servicio);
    } else {
      this.serviciosSeleccionados = this.serviciosSeleccionados.filter(s => s.additional_id !== servicio.additional_id);
    }
    this.calcularTotal();
  }

  calcularTotal() {
    // Calcular noches
    this.noches = 0;
    if (this.form.checkInDate && this.form.checkOutDate) {
      const inDate = new Date(this.form.checkInDate);
      const outDate = new Date(this.form.checkOutDate);
      if (outDate > inDate) {
        this.noches = Math.ceil((outDate.getTime() - inDate.getTime()) / (1000 * 3600 * 24));
      }
    }
    // Subtotal habitación: noches * precio * personas
    const numPersonas = Number(this.form.numAdults) + Number(this.form.numChildren) + Number(this.form.numInfants);
    const subtotalHabitacion = this.noches * (Number(this.form.roomCost) || 0) * (numPersonas > 0 ? numPersonas : 1);
    // Servicios adicionales
    const serviciosTotal = this.serviciosSeleccionados.reduce((acc, s) => acc + (Number(s.cost) || 0), 0);
    this.total = subtotalHabitacion + serviciosTotal;
  }

  onPersonasChange() {
    this.validarCantidadHuespedes();
    this.calcularTotal();
  }

  onFechaChange() {
    this.calcularTotal();
  }

  validarCantidadHuespedes() {
    const numEsperado = Number(this.form.numAdults) + Number(this.form.numChildren) + Number(this.form.numInfants);
    const numActual = this.huespedes.length;
    if (numActual < numEsperado) {
      this.mensajeHuespedes = `Faltan ${numEsperado - numActual} huésped(es) por registrar.`;
    } else if (numActual > numEsperado) {
      this.mensajeHuespedes = `Hay ${numActual - numEsperado} huésped(es) extra.`;
    } else {
      this.mensajeHuespedes = '';
    }
  }
  
  async cargarAlojamientosAsync() {
    await this.cargarAlojamientos();
  }

  extraerAlojamientosDelToken() {
    const user = this.tokenStorage.getUser();
    const alojamientosStr = user?.attributes?.['custom:alojamientos_ids'] || user?.['custom:alojamientos_ids'] || '';
    this.alojamientosIds = alojamientosStr ? alojamientosStr.split(',').map((id: string) => id.trim()).filter(Boolean) : [];
    console.log('[DEBUG] Alojamientos del admin:', this.alojamientosIds);
  }

  async cargarAlojamientos() {
    if (!this.alojamientosIds.length) return;
    const allHostings = await this.hostingService.getAllHostings();
    this.alojamientos = allHostings.filter(h => this.alojamientosIds.includes(h.id));
    console.log('[DEBUG] Alojamientos completos:', this.alojamientos);
  }

  async crearReserva() {
    this.loading = true;
    this.error = null;
    this.success = null;
    const accessToken = this.tokenStorage.getAccessToken();
    if (!accessToken) {
      this.error = 'No se encontró el token de acceso. Por favor, inicie sesión nuevamente.';
      this.loading = false;
      return;
    }
    try {
      // Enviar reserva con datos del cliente
      const reservationData = {
        ...this.form,
        userId: this.clienteId,
        email: this.clienteEmail
      };
      const reserva = await firstValueFrom(this.reservationService.createReservation(reservationData, accessToken));
      this.success = 'Reserva creada exitosamente.';
      this.error = null;
      console.log('[DEBUG] Reserva creada:', reserva);

      // Enviar huéspedes si hay y si la reserva tiene reservation_id
      if (this.huespedes.length > 0 && reserva?.reservation_id) {
        const huespedesPayload = this.huespedes.map(h => ({
          name: h.name,
          lastname: h.lastName,
          identificationType: h.idType,
          identificationNumber: h.idNumber,
          phone: h.phone,
          emergencyPhone: h.emergencyPhone,
          reservation_id: reserva.reservation_id
        }));
        try {
          const respHuespedes = await firstValueFrom(this.reservationService.addGuests(huespedesPayload));
          this.success += ' | Huéspedes registrados correctamente.';
          console.log('[DEBUG] Huéspedes registrados:', respHuespedes);
          this.huespedes = [];
        } catch (errHuesped: any) {
          this.error = 'Reserva creada pero hubo error registrando huéspedes: ' + (errHuesped?.message || 'Error desconocido');
        }
      }
      // Opcional: limpiar formulario
    } catch (err: any) {
      this.error = err?.message || 'Error creando la reserva.';
      this.success = null;
      console.error('Error creando reserva:', err);
    } finally {
      this.loading = false;
    }
  }
}